// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TAcceptConsentRequestPayload,
  TAcceptConsentResponsePayload,
  TExportExperienceSummaryV2RequestPayload,
  TExportExperienceSummaryV2ResponsePayload,
  TGetAIContentV2RequestPayload,
  TGetAIContentV2ResponsePayload,
  TGetAllGuidedExperiencesV2RequestPayload,
  TGetAllGuidedExperiencesV2ResponsePayload,
  TGetExperienceRequestPayload,
  TGetExperienceResponsePayload,
  TGetStepRequestPayload,
  TGetStepResponsePayload,
  TSetUserInputsRequestPayload,
  TSetUserInputsResponsePayload,
} from './ge-v2.types.ts';

export const createGeV2Api = (transport: TApiTransport) => ({
  /** Records user consent for a specific guided experience within a project */
  acceptConsent: (
    payload: TAcceptConsentRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TAcceptConsentRequestPayload, TAcceptConsentResponsePayload>(
      '/accept_consent',
      payload,
      options,
    ),

  /** Compiles a user's guided-experience session into a PDF summary and returns an identity-gated download URL, or, when summary_id is set, returns a previously exported PDF without regenerating it. Gated on the experience's summary_export_enabled flag. */
  exportExperienceSummaryV2: (
    payload: TExportExperienceSummaryV2RequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TExportExperienceSummaryV2RequestPayload,
      TExportExperienceSummaryV2ResponsePayload
    >('/export_experience_summary_v2', payload, options),

  /** Generate AI text content and select recommendations for a step. Split out of get_step_v2 so static step content can render immediately while AI content loads asynchronously. */
  getAiContentV2: (
    payload: TGetAIContentV2RequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetAIContentV2RequestPayload,
      TGetAIContentV2ResponsePayload
    >('/get_ai_content_v2', payload, options),

  /** Lists the project's guided experiences */
  getAllGuidedExperiencesV2: (
    payload: TGetAllGuidedExperiencesV2RequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetAllGuidedExperiencesV2RequestPayload,
      TGetAllGuidedExperiencesV2ResponsePayload
    >('/get_all_guided_experiences_v2', payload, options),

  /** Returns a guided experience */
  getExperienceV2: (
    payload: TGetExperienceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetExperienceRequestPayload, TGetExperienceResponsePayload>(
      '/get_experience_v2',
      payload,
      options,
    ),

  /** Returns a guided-experience step */
  getStepV2: (payload: TGetStepRequestPayload, options?: TApiRequestOptions) =>
    transport.post<TGetStepRequestPayload, TGetStepResponsePayload>(
      '/get_step_v2',
      payload,
      options,
    ),

  /** Records a guided-experience step's inputs */
  setUserInputsV2: (
    payload: TSetUserInputsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TSetUserInputsRequestPayload, TSetUserInputsResponsePayload>(
      '/set_user_inputs_v2',
      payload,
      options,
    ),
});
